import { BodyLargeBold } from '@src/fonts/typography/Typography';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;

  strong {
    text-align: center;
    ${BodyLargeBold};
    font-size: 18px;
    color: #464646;
    font-weight: 600;
    max-width: 465px;
    width: 100%;

    @media (max-width: 600px) {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }

  p {
    ${BodyLargeBold};
    font-size: 18px;
    color: #464646;
    text-align: center;
    font-weight: 600;
  }
`;
